import { render, staticRenderFns } from "./SkillLeaf.vue?vue&type=template&id=a491ea1c&scoped=true&"
import script from "./SkillLeaf.vue?vue&type=script&lang=js&"
export * from "./SkillLeaf.vue?vue&type=script&lang=js&"
import style0 from "./SkillLeaf.vue?vue&type=style&index=0&id=a491ea1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a491ea1c",
  null
  
)

export default component.exports